import React from 'react';
import Modal2 from 'components/_shared/Modal2';
import MemberStatus from './components/MemberStatus';
import MemberDetails from 'components/holders_list/components/EligibilityComponents/MemberDetails';
import { CTAButton3 } from 'components/_shared/buttons';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import { MemberSearchResult } from 'types';

const useStyles = makeStyles(() => ({
    body: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '32px'
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginTop: '40px'
    },
    closeButton: {
        color: '#7378E8',
        fontSize: '14px',
        fontWeight: '600',
        textTransform: 'none !important'
    },
    btnDiv: {
        display: 'flex',
        justifyContent: 'center'
    }
}));

const iconStyle = {
    backgroundColor: '#E7EFFE',
    border: '2px solid #062D7A',
    color: '#062D7A',
    fontSize: '24px'
};

type ReenrollPopupProps = {
    member: MemberSearchResult;
    closeButtonText: string;
    handleCloseClick: () => void;
    handleReenroll: () => void;
};

const ReenrollPopup: React.FC<ReenrollPopupProps> = ({
    member,
    closeButtonText,
    handleCloseClick,
    handleReenroll
}) => {
    const classes = useStyles();
    member.pii_member_id = null;
    const memberName = member?.pii_first_name && member?.pii_last_name ? `${member.pii_first_name} ${member.pii_last_name}` : member?.name || '-';

    return (
        <Modal2
            onClose={handleCloseClick}
            additionalStyles={{ iconStyle: iconStyle }}
            iconName=""
            title="Reenroll"
        >
            <div className={classes.body}>
                <MemberStatus
                    photo={member.photo}
                    icon="far fa-check"
                    title={`We have ${memberName} on file!`}
                    subtext={`We have some of ${memberName}'s information from either a previous membership or another partner. We'll pre-fill what we know into the sign up to make things a little easier for you.`}
                    colorType="green"
                />
                <MemberDetails member={member} />
                <div className={classes.buttonContainer}>
                    <CTAButton3 onClick={handleReenroll}>
                        Continue with Existing Information
                    </CTAButton3>
                </div>
                <div className={classes.btnDiv}>
                    <Button className={classes.closeButton} onClick={handleCloseClick}>
                        {closeButtonText}
                    </Button>
                </div>
            </div>
        </Modal2>
    );
};

export default ReenrollPopup;
